var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"embed-responsive embed-responsive-1by1",attrs:{"show":_vm.isLoading}},[_c('iframe',{staticClass:"embed-responsive-item",class:{ 'd-none': _vm.isLoading },attrs:{"src":_vm.pigeonUrl},on:{"load":_vm.onIframeLoaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }